import { useState, useEffect } from 'react';
import './GameRates.css';

function GameRates({ onBack, onOpenSidebar }) {
  const [gameRates, setGameRates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGameRates = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://backend.mainbazar777.site/api/rates');
        
        if (!response.ok) {
          throw new Error('Failed to fetch game rates');
        }
        
        const data = await response.json();
        
        if (data.success && data.market_rates) {
          const formattedRates = data.market_rates.map(rate => ({
            name: rate.market_name,
            rate: `${rate.value1}-${rate.value2}`
          }));
          setGameRates(formattedRates);
        }
        setLoading(false);
      } catch (err) {
        console.error('Error fetching game rates:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchGameRates();
  }, []);

  return (
    <div className="game-rates-page">
      {/* Header */}
      <div className="game-rates-header">
        <button className="back-btn" onClick={onBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1>Game Rates</h1>
        <div className="header-spacer"></div>
      </div>

      {/* Content */}
      <div className="game-rates-content">
        {/* Info Card */}
        <div className="rates-info-card">
          <h2 className="rates-title">Game <span className="rates-highlight">Rates</span></h2>
          <p className="rates-subtitle">We have Best Game Rates for you</p>
          
          {/* Rates List */}
          <div className="rates-list">
            {loading ? (
              <div className="loading-state">
                <p>Loading game rates...</p>
              </div>
            ) : error ? (
              <div className="error-state">
                <p>Error: {error}</p>
              </div>
            ) : gameRates.length > 0 ? (
              gameRates.map((game, index) => (
                <div key={index} className="rate-item">
                  <span className="game-name">{game.name}</span>
                  <span className="game-rate">{game.rate}</span>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <p>No game rates available</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GameRates;
